import React from 'react';

import { Card as CardUI } from '@material-ui/core';

import classes from './Card.module.scss';

const Card = ({
  children,
  type,
  title,
  titleId = 'card-title',
  subtitle,
  className,
  contentPadding,
}) => (
  <CardUI className={`${classes.Card} ${type} ${className}`}>
    {title && (
      <h3 className={classes.Card_title} id={titleId}>
        {title}
      </h3>
    )}
    {subtitle && <h4 className={classes.Card_subtitle}>{subtitle}</h4>}
    <div style={{ width: '100%', height: `${contentPadding}px` }} />
    {children}
  </CardUI>
);

export default Card;
